import { render, staticRenderFns } from "./NextCasePopup.vue?vue&type=template&id=5d015ba0&scoped=true&"
import script from "./NextCasePopup.vue?vue&type=script&lang=js&"
export * from "./NextCasePopup.vue?vue&type=script&lang=js&"
import style0 from "./NextCasePopup.vue?vue&type=style&index=0&id=5d015ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d015ba0",
  null
  
)

export default component.exports